import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

interface AppTokenModalProps {
    isOpen: boolean,
    disabled: boolean
    header: string,
    body: string,
    toggleModal: () => void,
    confirm: () => void,
}

const AppTokenModal = (props: AppTokenModalProps) => {
    const { t } = useTranslation('common');

    return (
        <Modal isOpen={props.isOpen} toggle={props.toggleModal}>
            <ModalHeader>{props.header}</ModalHeader>
            <ModalBody>{props.body}</ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={props.toggleModal}>{t('no')}</Button>
                <Button color="primary" onClick={props.confirm} disabled={props.disabled}>{t('yes')}</Button>
            </ModalFooter>
        </Modal>
    );
}

export default AppTokenModal;
